import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardHeader, CardContent, Grid, makeStyles, Link, Typography } from '@material-ui/core';
import { Channel } from '../../utils/types';
import SimpleTextInfo from '../common/SimpleTextInfo';
import VideoAssets from './VideoAssets';
import EditIcon from '@material-ui/icons/Edit';
import Airings from '../airings/Airings';

const useStyles = makeStyles((theme) => ({
	gameActionLink: {
		color: theme.palette.secondary.main,
		display: 'flex',
		marginBottom: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			justifyContent: 'flex-end'
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2)
		}
	},
	linkText: {
		marginLeft: theme.spacing(0.5)
	}
}));

export const ChannelDetails: React.FC<Channel> = (props) => {
	const { id, name, language, territory, type, highlights, sourceAssets, mediaLiveId, mediaPackageId } = props;
	const classes = useStyles();

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Card>
					<CardHeader title='Channel details' />
					<CardContent>
						<Grid container>
							<Grid container item sm={12} md={8} direction='column' spacing={2}>
								<SimpleTextInfo label='ID' value={id ?? ''} to={`/channels/${encodeURIComponent(id ?? '')}`} />
								<SimpleTextInfo label='Name' value={name ?? ''} />
								<SimpleTextInfo
									label='Media Live ID'
									value={mediaLiveId ?? type?.toString() === 'EXTERNAL' ? 'Not Applicable for External channel type' : ''}
								/>
								<SimpleTextInfo
									label='Media Package ID'
									value={mediaPackageId ?? type?.toString() === 'EXTERNAL' ? 'Not Applicable for External channel type' : ''}
								/>
								<SimpleTextInfo label='Language' value={language ?? ''} />
								<SimpleTextInfo label='Territory' value={territory ?? ''} />
								<SimpleTextInfo label='Type' value={type ?? ''} />
								<SimpleTextInfo label='Highlights' value={highlights ? 'true' : 'false'} />
							</Grid>
							<Grid item sm={12} md={4}>
								<Link component={RouterLink} to={`/channels/${id}/edit`} className={classes.gameActionLink}>
									<EditIcon data-testid='channel-details-action-edit' />
									<Typography className={classes.linkText}>Edit</Typography>
								</Link>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} lg={12}>
				<VideoAssets videoAssets={sourceAssets?.items ?? []} />
			</Grid>
			<Grid item xs={12} lg={12}>
				<Airings channelId={`${id}#`} />
			</Grid>
		</Grid>
	);
};

export default ChannelDetails;
